import Vue from 'vue'

const CBO = process.env.VUE_APP_API_URL_CONNECTOR_CBO
const CBO_JOBUP = process.env.VUE_APP_API_URL_CONNECTOR_CBO_JOBUP

export const cboService = {
    async getItems(list) {
        try {
            if (list === 'JobUpSubCategory') {
                return await Vue.axios.post(CBO_JOBUP.slice(0, -1), {}).then((response) => response.data)
            } else {
                return await Vue.axios
                    .post(CBO.slice(0, -1), {
                        list: list,
                        subSystemCode: 'ODM',
                        onlyActiveEntries: 1,
                    })
                    .then((response) => response.data)
            }
        } catch (error) {
            return Promise.reject(error)
        }
    },
}
